import * as Yup from "yup";

export const qualityAdhesionValidation = Yup.object().shape({
  id: Yup.number().nullable().required(),
  material_category_id: Yup.number().nullable(),
  material_id: Yup.number().nullable(),
  order_id: Yup.number().nullable(),
  dynamic_tracker_fields: Yup.array()
    .of(Yup.string().required())
    .min(1, "At least one dynamic field is required")
    .required("Dynamic tracker fields are required"),
});
